import { formatUrl as formatUrlFrontendUtils } from 'frontend-utils/utils/url/format-url';
import {
  APIGATEWAY,
  BEST_FLEX,
  COMPARETYPES,
  FLEXIBLE,
  RATE_PARAMS,
  RATETYPES,
} from 'lumen/utils/constants/general-constants';
import { RATE_TYPES } from 'lumen/utils/constants/pi-constant-values';
import { isComparingRates } from 'lumen/utils/is-comparing-rates';

/**
 * Map the rateParam QP (Frontend) onto the bar, rate_type and flexible QPs for Backend
 *
 * @param  { string } rateParam : The rateParam QP (possible values: RATE_PARAMS)
 * @param  { object } params : The object where the bar, rate_type and flexible keys need to be added to
 */
export function mapRateParamToAPIParams(rateParam, params) {
  switch (rateParam) {
    case RATE_PARAMS.BEST_FLEX:
    case RATE_TYPES.BEST_FLEX:
    case 'best_flex':
      // best_flex is a PriMa exception! Currently we're still tied to best_flex as rateParam by BE, but we have shared code with RateI in day-detail
      // Not changeable in short-term, but workaround to fix SH issue
      params.bar = BEST_FLEX;
      params.flexible = FLEXIBLE;
      params.rate_type = RATETYPES.NONE;
      break;
    case RATE_PARAMS.FLEXIBLE:
      params.bar = !BEST_FLEX;
      params.flexible = FLEXIBLE;
      params.rate_type = RATETYPES.NONE;
      break;
    case RATE_PARAMS.LOWEST:
    case RATE_TYPES.LOWEST:
      params.bar = !BEST_FLEX;
      params.flexible = !FLEXIBLE;
      params.rate_type = RATETYPES.NONE;
      break;
    case RATE_PARAMS.THIRD_PARTY:
      params.bar = !BEST_FLEX;
      params.flexible = !FLEXIBLE;
      params.rate_type = RATETYPES.THIRD_PARTY;
      break;
    default:
      break;
  }
}

export function mapCompareParamsToAPIParams(queryParams, apiParams) {
  const { compareType, compareValue } = queryParams;
  if (isComparingRates(compareType, compareValue)) {
    if (compareType === COMPARETYPES.RATE_PARAM) {
      const compareParams = {};
      mapRateParamToAPIParams(compareValue, compareParams);
      Object.keys(compareParams).forEach((key) => {
        apiParams[`compare_${key}`] = compareParams[key];
      });
    } else {
      apiParams[`compare_${compareType}`] = compareValue;
    }
  }
}

export function mapQueryParamsToAPIParams(queryParams, startDate, endDate) {
  const apiParams = {
    compset_ids: queryParams.compsetId,
    los: queryParams.los,
    mealtype: queryParams.mealPlan,
    membershiptype: queryParams.membershipType,
    ota: queryParams.otaId,
    persons: queryParams.maxPersons,
    platform: queryParams.platform,
    roomtype: queryParams.roomType,
    from_date_range_start: startDate,
    from_date_range_end: endDate,
  };

  mapRateParamToAPIParams(queryParams.rateParam, apiParams);
  mapCompareParamsToAPIParams(queryParams, apiParams);

  return apiParams;
}

export function requestRates(model, hotelId, params, store) {
  const requestPeriods = {
    namespace: APIGATEWAY,
    typeKey: 'rates',
    from_date_range_start: params.from_date_range_start,
    from_date_range_end: params.from_date_range_end,
    hotel_id: hotelId,
  };

  Object.keys(params).forEach((key) => {
    requestPeriods[key] = params[key];
  });

  return store.query(model, requestPeriods);
}

// Wrapper for formatUrl function in frontend-utils that automatically takes care of the rateParam
export function formatUrl(path, params, host = '') {
  if ('rate_param' in params) {
    mapRateParamToAPIParams(params.rate_param, params);
    delete params.rate_param;
  }

  return formatUrlFrontendUtils(path, params, host);
}
